var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 4.00017C17.0168 4.00017 18.6668 5.65017 18.6668 7.66684C18.6668 9.68351 17.0168 11.3335 15.0002 11.3335C12.9835 11.3335 11.3335 9.68351 11.3335 7.66684C11.3335 5.65017 12.9835 4.00017 15.0002 4.00017ZM15.0002 22.3335C19.9502 22.3335 25.6335 24.6985 26.0002 26.0002H4.00016C4.42183 24.6802 10.0685 22.3335 15.0002 22.3335ZM15.0002 0.333496C10.9485 0.333496 7.66683 3.61517 7.66683 7.66684C7.66683 11.7185 10.9485 15.0002 15.0002 15.0002C19.0518 15.0002 22.3335 11.7185 22.3335 7.66684C22.3335 3.61517 19.0518 0.333496 15.0002 0.333496ZM15.0002 18.6669C10.1052 18.6669 0.333496 21.1235 0.333496 26.0002V29.6669H29.6668V26.0002C29.6668 21.1235 19.8952 18.6669 15.0002 18.6669Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProfile);
export default __webpack_public_path__ + "static/media/emptyProfile.88f783a6a1d3701fa5c2e11dfca7d3cd.svg";
export { ForwardRef as ReactComponent };